var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('v-footer',{attrs:{"color":"primary"}},[_c('v-flex',{attrs:{"text-xs-center":""}},[_c('h6',[_vm._v("We Are An Equal Opportunity Employer")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }